import { render, staticRenderFns } from "./memberSquare.vue?vue&type=template&id=51c28eda&"
import script from "./memberSquare.vue?vue&type=script&lang=js&"
export * from "./memberSquare.vue?vue&type=script&lang=js&"
import style0 from "./memberSquare.vue?vue&type=style&index=0&id=51c28eda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports